import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "@tanstack/react-router";
import { useSession } from "~/contexts/auth-context";
import CenteredPageWithHeroIllustrationImageOnBottomRight from "~/components/page/centered-page-with-hero-illustration-image-on-bottom-right";
import { Button } from "~/components/button";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { ProfilePicture } from "~/components/user/profile-picture";
import { Text } from "~/components/text";

export const Profile: React.FC = () => {
  const { t } = useTranslation(["general", "profile"]);
  const { user, organisation } = useSession();
  const { email, name, photoUrl } = user;
  const location = useLocation();
  const navigate = useNavigate();
  const { prevPath = "/", prevSearch = "" } = location.state;
  const href = `${prevPath}${prevSearch}`;

  return (
    <CenteredPageWithHeroIllustrationImageOnBottomRight>
      <div className="flex flex-col w-1/2 gap-6 items-start">
        <ProfilePicture
          photoUrl={photoUrl}
          className=" h-32 w-32 mb-4 mt-4"
          name={name}
        />
        <Text variant="title">{t("profile:header")}</Text>
        <Label htmlFor="email">Email</Label>
        <Input
          value={email || ""}
          type="email"
          id="email"
          disabled
          placeholder="Email"
        />
        <Label htmlFor="fullName">Name</Label>
        <Input
          value={name}
          type="name"
          id="name"
          disabled
          placeholder="Email"
        />
        <Label htmlFor="organisation">Organisation</Label>
        <Input
          value={organisation.name}
          type="string"
          id="organisation"
          disabled
          placeholder="Organisation"
        />
        <Button
          variant="primary"
          label={t("profile:buttons.back")}
          icon="arrow-left"
          iconPosition="left"
          onClick={() => navigate({ href })}
          analyticsId="button_back_from_profile_page"
        />
      </div>
    </CenteredPageWithHeroIllustrationImageOnBottomRight>
  );
};
